import React from 'react';
import TabbedSection from '../components/TabbedSection';

import AffiliateProgramme from './Affiliate/AffiliateProgramme';
import AffiliateManagement from './Affiliate/AffiliateManagement';
import LinkApprovalQueue from './Admin/LinkApprovalQueue';
import ApiAccessRequestQueue from './Admin/ApiAccessRequestQueue';

/**
 * The affiliate programme and the queues that feed it.
 *
 * The commission programme leads: it is the one that moves money and the one
 * youguide.com signups land in. "All Affiliates" is the older white-label
 * partner CRUD over the same accounts.
 */
const TABS = [
    { key: 'programme', label: 'Affiliate Programme', Component: AffiliateProgramme },
    { key: 'all', label: 'All Affiliates', Component: AffiliateManagement },
    { key: 'link-approvals', label: 'Link Approvals', Component: LinkApprovalQueue },
    { key: 'api-approvals', label: 'API Access Approvals', Component: ApiAccessRequestQueue },
];

const AffiliatesSection = () => (
    <TabbedSection title="Affiliates" basePath="/affiliates-section" tabs={TABS} />
);

export default AffiliatesSection;
